module.exports = __webpack_public_path__ + "img/southernrock_alpha.e8996ae3.png";